(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-tys-home]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      root.querySelectorAll('.te-mobile-nav a').forEach(link => link.addEventListener('click', () => link.closest('details').removeAttribute('open')));
      root.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const menu = root.querySelector('.te-mobile-nav[open]');
        if (menu) { menu.removeAttribute('open'); menu.querySelector('summary').focus(); }
      });
      const header = root.querySelector('.te-header');
      const hero = root.querySelector('.te-hero');
      const setHeaderMode = overHero => {
        header.classList.toggle('te-header-paper', !overHero);
        header.style.backgroundColor = overHero ? '#181818b3' : '#f7f7f2';
        header.style.color = overHero ? '#f7f7f2' : '#181818';
        header.style.borderColor = overHero ? '#ffffff55' : '#181818';
      };
      if (root.hasAttribute('data-tys-homepage') && header && hero && 'IntersectionObserver' in window) {
        const headerObserver = new IntersectionObserver(([entry]) => {
          setHeaderMode(entry.isIntersecting);
        }, { rootMargin: `-${header.offsetHeight}px 0px 0px 0px` });
        headerObserver.observe(hero);
      }
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
